<template>
  <CheckoutStep>
    <Loading
      v-if="isLoading"
      :pending="status === 'pending'"
      @animation-ended="() => (isLoading = false)"
    />

    <BouyguesError v-if="!isLoading && error" @try-again="refresh" />

    <BouyguesAccount
      v-if="!isLoading && bouyguesAccount"
      :is-account-existing="bouyguesAccount.existing"
    />
  </CheckoutStep>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { ref } from 'vue'

import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUser } from '~/scopes/checkout/composables/useUser'

import BouyguesError from '../../components/BouyguesError/BouyguesError.vue'

import BouyguesAccount from './components/BouyguesAccount/BouyguesAccount.vue'
import Loading from './components/Loading/Loading.vue'

const user = useUser()
const $httpFetch = useHttpFetch()

defineOptions({
  inheritAttrs: false,
})

const {
  data: bouyguesAccount,
  status,
  error,
  refresh,
} = useAsyncData(() => {
  return $httpFetch('/mobile-plan/api/v1/customer-account/status', {
    method: 'POST',
    body: {
      partner: 'BOUYGUES_TELECOM',
      email: user.email,
    },
  })
})

const isLoading = ref(true)
</script>
